// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const language = localStorage.getItem("language") ?? "en";
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: require("../src/assets/i18n/en.json"),
    },
    hi: {
      translation: require("../src/assets/i18n/hi.json"),
    },
  },
  lng: language,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
